import { useMemo } from 'react';
import { Alert, Box, Text } from '@nimbus-ds/components';
import { AbandonedCartPaymentAttemptDto } from '@tiendanube/common';
import { dateFormat, Format } from 'commons/utils/date';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';
import { PaymentMethodTitle } from './PaymentMethodTitle';
import usePaymentErrorCodeTranslation from './usePaymentErrorCodeTranslation';

interface LatestPaymentAttemptProps {
  attempt: AbandonedCartPaymentAttemptDto;
}

export function LatestPaymentAttempt({
  attempt,
}: Readonly<LatestPaymentAttemptProps>) {
  const t = useTranslationOrders();
  const translateErrorCode = usePaymentErrorCodeTranslation(
    attempt.payment?.integrationType,
  );

  const installments = attempt.payment?.installments;

  const showInstallments = useMemo(
    () => !!installments && installments > 1,
    [installments],
  );

  return (
    <Box display="flex" flexDirection="column" gap="2" alignItems="flex-start">
      {!!attempt.createdAt && (
        <Text fontSize="caption" color="neutral-textLow">
          {dateFormat(attempt.createdAt, Format.DAY_HOUR_MINUTE)}
        </Text>
      )}
      <PaymentMethodTitle attempt={attempt} />
      {showInstallments && (
        <Text>
          {t('cardPayment.installments', {
            count: installments,
          })}
        </Text>
      )}
      <Box marginTop="2" marginBottom="2">
        <Alert appearance="danger" show>
          <Text fontSize="base" fontWeight="regular" color="danger-textLow">
            {translateErrorCode(attempt.errorCode)}
          </Text>
        </Alert>
      </Box>
    </Box>
  );
}
